module.exports = __webpack_public_path__ + "static/media/banner_img.378e2312.png";